module.exports = new __parcel__URL__("elevation-map.9e064d3e.png").toString();